var _path, _path2, _path3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAdminHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "System_Administrator_-_second",
    "data-name": "System Administrator - second",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.542,
    height: 80,
    viewBox: "0 0 79.542 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_133015",
    "data-name": "Path 133015",
    d: "M75.507,2.5H18.669A3.29,3.29,0,0,0,15.38,5.789V32.963a10.542,10.542,0,0,1,3.543-.609h11.2a3.821,3.821,0,0,1,3.81,3.81V48.1H75.507A3.29,3.29,0,0,0,78.8,44.811V5.789A3.29,3.29,0,0,0,75.507,2.5ZM64.129,27.4a1.171,1.171,0,0,1-.978,1.156l-4.254.724,2.489,3.53a1.157,1.157,0,0,1-.127,1.5l-2.768,2.768a1.157,1.157,0,0,1-1.5.127l-3.53-2.489-.724,4.254a1.171,1.171,0,0,1-1.156.978H47.672a1.171,1.171,0,0,1-1.156-.978l-.724-4.254L42.25,37.2a1.141,1.141,0,0,1-1.486-.127l-2.781-2.768a1.172,1.172,0,0,1-.127-1.5l2.5-3.53-4.267-.724a1.172,1.172,0,0,1-.965-1.156V23.491a1.172,1.172,0,0,1,.965-1.156l4.267-.724-2.5-3.543a1.156,1.156,0,0,1,.127-1.486L40.764,13.8a1.172,1.172,0,0,1,1.486-.127l3.543,2.5.724-4.267a1.172,1.172,0,0,1,1.156-.965h3.911a1.172,1.172,0,0,1,1.156.965l.724,4.267,3.53-2.5a1.188,1.188,0,0,1,1.5.127l2.768,2.781a1.141,1.141,0,0,1,.127,1.486L58.9,21.611l4.254.724a1.171,1.171,0,0,1,.978,1.156Z",
    transform: "translate(0.747 -2.5)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133016",
    "data-name": "Path 133016",
    d: "M22.061,54.651A10.318,10.318,0,0,0,32.372,44.34V29.28a1.274,1.274,0,0,0-1.27-1.27H19.9a8.167,8.167,0,0,0-8.152,8.1V44.34A10.318,10.318,0,0,0,22.061,54.651ZM14.29,41.318H25.883A6.726,6.726,0,0,0,29.642,40.1a1.652,1.652,0,0,0,.19-.127V44.34a7.771,7.771,0,0,1-15.543,0Z",
    transform: "translate(-0.233 4.384)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133017",
    "data-name": "Path 133017",
    d: "M34.451,47.27a12.863,12.863,0,0,1-7.682,4.521L25.143,53.4a.9.9,0,0,1-1.282,0l-1.613-1.613a12.746,12.746,0,0,1-6.819-3.555c-.3-.3-.6-.635-.876-.965A15.124,15.124,0,0,0,2.68,62.013v7.137a1.274,1.274,0,0,0,1.27,1.27h41.1a1.274,1.274,0,0,0,1.27-1.27V62.013A15.1,15.1,0,0,0,34.451,47.27Z",
    transform: "translate(-2.68 9.581)",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1568",
    "data-name": "Ellipse 1568",
    cx: 5.938,
    cy: 5.938,
    rx: 5.938,
    ry: 5.938,
    transform: "translate(42.632 26.159) rotate(-67.486)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAdminHover);
export default __webpack_public_path__ + "static/media/SystemAdminHover.69326957b5d2f35f1318da69901411fe.svg";
export { ForwardRef as ReactComponent };